// Reservation Details action types
/**
 * THIS FILE IS NOW DEPRECATED AND WILL BE REMOVED IN THE NEXT MAJOR RELEASE.
 * PLEASE, DO NOT ADD ANY NEW CODE HERE.
 */
const reservationDetailsActionTypes = {
  FETCH_RESERVATION_DETAILS_REQUEST: 'FETCH_RESERVATION_DETAILS_REQUEST',
  FETCH_RESERVATION_DETAILS_SUCCESS: 'FETCH_RESERVATION_DETAILS_SUCCESS',

  FETCH_RESERVATION_DETAILS_FAILURE: 'FETCH_RESERVATION_DETAILS_FAILURE',
  FETCH_RESERVATION_DETAILS_CLEAR: 'FETCH_RESERVATION_DETAILS_CLEAR',
  RESERVATION_DETAILS_CABANA_IS_LOADING: 'RESERVATION_DETAILS_CABANA_IS_LOADING',
  RESERVATION_DETAILS_CABANA_SUCCESS: 'RESERVATION_DETAILS_CABANA_SUCCESS',
  RESERVATION_DETAILS_CABANA_FAILURE: 'RESERVATION_DETAILS_CABANA_FAILURE',
  CLEAR_RESERVATION_DETAILS_CABANA_DETAILS: 'CLEAR_RESERVATION_DETAILS_CABANA_DETAILS',
  CLEAR_RESERVATION_DETAILS_DETAILS_ERROR: 'CLEAR_RESERVATION_DETAILS_DETAILS_ERROR',
  FETCH_RESERVATION_DYNAMIC_TILE_SUCCESS: 'FETCH_RESERVATION_DYNAMIC_TILE_SUCCESS'
};

export default reservationDetailsActionTypes;
